/**
 * What each route calls itself in the browser tab (M13.7, WCAG 2.4.2 Page Titled).
 *
 * Until M13.7 the tenant bootstrap wrote one title — "<clinic> — Booking" — and left it
 * there, so a patient reviewing their visit at `/account/appointments/:id` had a tab that
 * said "Booking", and eight portal screens were indistinguishable in the history. The
 * copy here is each screen's own `h1`, so the tab and the page agree.
 *
 * Longest prefix wins. Anything unlisted falls back to the clinic name alone, which is
 * the right answer for a route this map has not heard of.
 */
const TITLES: [prefix: string, title: string][] = [
  ['/book', 'Book your appointment'],
  ['/insurance', 'Verify your insurance'],
  ['/payment', 'Payment'],
  ['/paperwork', 'Your paperwork'],
  ['/login', 'Sign in'],
  ['/register', 'Create an account'],
  ['/reset-password', 'Reset your password'],
  ['/auth/link', 'Your sign-in link'],
  ['/auth/secure-link', 'Your secure link'],
  ['/account/appointments', 'Your visit'],
  ['/account/intake', 'Your paperwork'],
  ['/account/messages', 'Your messages'],
  ['/account/payment', 'Your payment method'],
  ['/account/preferences', 'Your reminders'],
  ['/account/profile', 'Your details'],
  ['/account/waitlist', 'Your waitlist places'],
  ['/account', 'Your appointments'],
];

export function pageTitle(pathname: string, clinic: string): string {
  const match = TITLES.filter(
    (entry) => pathname === entry[0] || pathname.startsWith(`${entry[0]}/`),
  )
    .sort((a, b) => b[0].length - a[0].length)
    .at(0);
  return match === undefined ? clinic : `${match[1]} · ${clinic}`;
}
